import { defineStore } from "pinia";
import axios from 'axios';
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
export const useGajiPokokSkemaStore = defineStore('gajiPokokSkemaStore', {
    state: () => ({
        data: null
    }),
    getters: {
        filter(){
            return this.data.filter(g => g.nama);
        }
    },
    actions: {
        async get() {
          // Fetch data only if it hasn't been fetched before
          
          if (!this.data) {
            try {
              const config = {
                headers: {
                  Authorization: api.defaults.headers.common["Authorization"],
                  "content-type": "application/json",
                },
              };
              const response = await axios.get( `${API_BASE_URL}/gajiPokokSkema`,config);  // Replace with your API endpoint
              this.data = response.data;
            } catch (error) {
              console.error('gajiPokokSkemaStore Error fetching:', error);
            }
          }

          return this.data;
         
        },
       
        async reset() {  // Add async
          this.data = null;  // Clear the store
          
          const newData = await this.get();  // Fetch new data
          
          this.data = newData;  // Store the fetched data
          return this.data;  // Ensure reset() returns the data
      }
        
    },
     onInit() {
        this.get();
    },
    persist: true,
    onBeforeMount() {
      this.get();
  },

});